module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_7042.4499cfb7.png";